import React from 'react';
import { formatMacro } from '@shared/utils/formatting';

interface NutritionSummaryProps {
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    themeColor: string;
}

export const NutritionSummary: React.FC<NutritionSummaryProps> = ({
    calories, protein, carbs, fat, themeColor
}) => {
    return (
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px', 
            marginTop: '12px', 
            padding: '8px 12px', 
            backgroundColor: 'rgba(0,0,0,0.2)', 
            borderRadius: '8px',
            border: '1px solid rgba(255,255,255,0.03)',
            width: 'fit-content'
        }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <span style={{ fontSize: '8px', fontWeight: '900', color: themeColor, opacity: 0.6 }}>ENERGY</span>
                <span style={{ fontSize: '13px', fontWeight: '900', color: '#fff' }}>{formatMacro(calories)} <span style={{ fontSize: '9px', color: themeColor }}>KC</span></span>
            </div>
            
            <div style={{ width: '1px', height: '20px', backgroundColor: '#222' }} />

            <div style={{ display: 'flex', gap: '10px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <span style={{ fontSize: '8px', fontWeight: '900', color: '#3b82f6', opacity: 0.6 }}>PRO</span>
                    <span style={{ fontSize: '11px', fontWeight: '900', color: '#fff' }}>{formatMacro(protein)}<span style={{ fontSize: '8px', color: '#3b82f6' }}>G</span></span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <span style={{ fontSize: '8px', fontWeight: '900', color: '#2ecc71', opacity: 0.6 }}>CARB</span>
                    <span style={{ fontSize: '11px', fontWeight: '900', color: '#fff' }}>{formatMacro(carbs)}<span style={{ fontSize: '8px', color: '#2ecc71' }}>G</span></span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <span style={{ fontSize: '8px', fontWeight: '900', color: '#f29b11', opacity: 0.6 }}>FAT</span>
                    <span style={{ fontSize: '11px', fontWeight: '900', color: '#fff' }}>{formatMacro(fat)}<span style={{ fontSize: '8px', color: '#f29b11' }}>G</span></span>
                </div>
            </div>
        </div>
    );
};
